module.exports = __webpack_public_path__ + "img/img1.5cdd6826.jpg";